module.exports = __webpack_public_path__ + "img/icon-search.4cee3287.svg";